export default __webpack_public_path__ + "static/media/OMOBOSOLA SUIT - Product & Digital Marketing and AI Automation Support Person.d60219c4.png";